// extracted by mini-css-extract-plugin
export default {"chip":"TeamsSections__chip--B27GGO_2PwoFRXKPscWT"};